/*
## Custom form components

`RichForm` can render custom React components for specific fields. Provide a
`componentId` in the `FieldSpec` and register the component during
initialisation:

```ts
import { registerComponent } from './components/rich/component-registry'
import MyComponent from './my-field-component'

registerComponent('MyComponent', MyComponent)

// FieldSpec example
{
  id: 'preview',
  title: 'Preview',
  kind: 'placeholder',
  componentId: 'MyComponent',
}
```
*/

import { ComponentType } from 'react'

const componentRegistry: Record<string, ComponentType<any>> = {}

export function registerComponent(id: string, component: ComponentType<any>) {
  componentRegistry[id] = component
}

export function getComponent(id: string) {
  return componentRegistry[id]
}

export { componentRegistry }
